export const generativeAiAppGroupIdVariantGenerationAssistant =
  "/:app_group_id/generative_ai/variant_generation_assistant";
